import { api } from "../services/api.js";

export async function getReporteClientes(fecha, id_supervisor) {
  try {
    let ruta = `/reportes/clientes?fecha='${fecha}'`;

    ruta += id_supervisor ? `&id_supervisor=${id_supervisor}` : "";

    const response = await api.get(ruta);
    return response.data;
  } catch (error) {
    console.error("Error al obtener el reporte de los clientes:", error);
    throw error;
  }
}
